import { render } from "./VerificationFail.vue?vue&type=template&id=85ca71e0&scoped=true&ts=true"
import script from "./VerificationFail.vue?vue&type=script&lang=ts"
export * from "./VerificationFail.vue?vue&type=script&lang=ts"

import "./VerificationFail.vue?vue&type=style&index=0&id=85ca71e0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ca71e0"]])